import React, {PureComponent} from 'react';
import {TableCell} from "@material-ui/core";
import formatValue from "../../../../../Utils/ListUtils/FormatValue";
import conditionalFormatting from "../../../../../Utils/ListUtils/conditionalFormatting";

class TableCellList extends PureComponent {


    render() {
        const {value, column, column: {conditionalFormat}, type} = this.props;
        let style = conditionalFormat ? conditionalFormatting(value, conditionalFormat) : {};
        return (
            !column.hidden && (
                <TableCell style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    padding: '4px 16px 4px 16px',
                    textAlign: (column.type === "number" || column.type === "integer") ? "right" : "left",
                    ...style
                }}>
                    {value && formatValue(value, type ? type: column.type, column.format)}
                </TableCell>
            )
        );
    }
}

export default TableCellList;